<template>
	<section>
		<header-page
			actions
			name="accounting-accounts"
			:title="title"
			to-show
			:show-clean="false"
			:show-excel="false"
			@run-action="runAction"
		>
			<v-flex pr-5 body-2 hidden-sm-and-down>
				AÑO CONTABLE: {{ year }}
			</v-flex>
		</header-page>
		<backButtonRoute/>
		<tree-table
			:tree-data="accountingAccounts"
			@click-icon="onClickIcon"
			@update="loadAccountingAccounts"></tree-table>
		<action-bar
			class="action-mobile"
			:resource-uri="$route.name"
			@run-action="runAction"
		/>
		<action-sidebar
				:title="action.title"
				:value="action.value"
				:width="action.width"
				@close-modal="closeModal"
			>
			<v-layout  wrap ma-2 v-if="action.code === 'accounting-accounts'">
				<form-sidebar>
				<v-form>
				<v-layout wrap align-center>
					<v-flex xs12>
							<v-text-field
								disabled
								background-color="white"
								box
								class="body-1"
								:height="48"
								hide-details
								label="Cuenta Contable"
								v-model="model.account"
							>
							</v-text-field>
						</v-flex>
					<v-flex>
							<v-text-field
								disabled
								background-color="white"
								box
								class="body-1"
								:height="48"
								hide-details
								label="Código Contable"
								type="number"
								v-model="model.code"
							></v-text-field>
						</v-flex>
						<v-flex xs12>
							<v-text-field
								background-color="white"
								box
								class="body-1"
								:height="48"
								hide-details
								label="Nombre"
								v-model="model.name"
							></v-text-field>
							<span slot="error" class="form-group__message error--text" v-if="!$v.model.name.required">
								El nombre de la cuenta contable es requerida
							</span>
						</v-flex>
				</v-layout>
				</v-form>
				</form-sidebar>
			<section class="modal-filter-footer">
			<modal-sidebar-button
				success-text="Aceptar"
				@cancel-button-clicked="closeModal"
				@accept-button-clicked="submitForm"
				:is-loading="disabled"
			>
			</modal-sidebar-button>
			</section>
			</v-layout>
			<v-layout  wrap ma-2 v-if="action.code === 'accounting-accounts-export'">
				<form-sidebar>
				<v-form>
				<v-layout wrap align-center>
					<label ref="label-export" for="export-excel">
						<v-layout>
						<v-flex xs12 mr-2 class="text-right">
							<v-btn
							color="success"
							class="btnExportExcel white--text"
							@click="exportRules()"
							>
							Exportar Plan de Cuentas 
							<v-icon right dark>file_upload</v-icon>
							</v-btn>
						</v-flex>
						</v-layout>
					</label>			
				</v-layout>
				</v-form>
				</form-sidebar>		
				<section class="modal-filter-footer">
			<modal-sidebar-button
				@cancel-button-clicked="closeModal"
				:is-loading="disabled"
			>
			</modal-sidebar-button>
			</section>	
			</v-layout>
			</action-sidebar>
		<v-dialog
			content-class="confirmation-dialog"
			v-model="dialog"
			max-width="400"
		>
			<v-card class="pa-4">
				<v-card-text class="title text-xs-center pt-4">{{ dialogMessage }}</v-card-text>
				<v-card-actions class="justify-center pb-4">
					<v-btn
						type="button"
						@click="closeDialog"
						color="success"
						class="btn-action mr-1 white--text">
						Cancelar
					</v-btn>
					<v-btn
						type="button"
						color="error"
						@click="onDelete"
						class="btn-action ml-1 white--text">
						Eliminar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<router-view></router-view>
		<v-dialog
	content-class="dialog-loading"
	max-width="300"
    persistent
	v-model="dialogLoading">
		<div class="container-loader">
			<label class="loading-search">
				Espere unos segundos por favor...
			</label>
			<div class="loader"></div>
		</div>
	</v-dialog>
	</section>
</template>

<script>
	import accountingAccountFilter from '@/components/accounting-accounts/accounting-account-filter';
	import { required } from 'vuelidate/lib/validators';
	import accountingAccountList from '@/components/accounting-accounts/accounting-account-list';
	import actionBar from '@/components/shared/action-bar/action-bar';
	import backButtonRoute from '@/components/shared/back-button-route';
	import actionSidebar from '@/components/shared/action-sidebar';
	import treeTable from '@/components/accounting-accounts/tree-accounting-accounts';

	function created() {
		this.loadAccountingAccounts();
		this.dataSelected = [];
	}

	async function loadAccountingAccounts() {
		this.dialogLoading = true;
		const params = {
			sortField: 'code',
			sortDirection: 'ASC',
			flag: true,
		};
		try {
			const { data: response } = await this.$http.get(`com-accounting-accounts/${this.id}/plan`, { params });
			this.accountingAccounts = response;
		} catch (error) {
			this.showGenericError();
		} finally {
			this.dialogLoading = false;
		}
	}

	function validations() {
		return {
			model: {
				name: { required },
			},
		};
	}
	function onLevel(account) {
		this.model.fatherAccount = account;
	}
	function disabled() {
		return this.$v.$invalid || this.flagCode;
	}

	function closeDialog() {
		this.dialog = false;
		this.dialogMessage = '';
		this.accountId = null;
	}
	async function submitForm() {
		this.loading = true;
		const method = 'post';
		const url = `com-accounting-accounts/${this.id}`;
		const action = 'creada';

		try {
			await this.$http[method](url, this.model);
			this.showNotification(`La cuenta ha sido ${action} correctamente`);
			this.loadAccountingAccounts();
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			} else if (err.status === 400) {
				if (err.data.message === 'ACCOUNTING_ACCOUNT_EXIST') {
					this.showGenericError('La cuenta ya existe.');
				} else if (err.data.message === 'ACCOUNTING_ACCOUNT_FATHER_NOT_FOUND"') {
					this.showGenericError('La cuenta padre no se encuentra registrada.');
				}
			}
		} finally {
			this.closeModal();
		}
	}

	function edit({ id }) {
		this.goTo(
			'accounting-account-edit',
			{
				params: {
					accountId: id,
					id: this.id,
					name: this.name,
					subsidiaryId: this.subsidiaryId,
					subsidiaryName: this.subsidiaryName,
					year: this.year,
				},
			},
		);
	}
	function closeModal() {
		this.action.value = false;
		this.action.title = '';
		this.action.code = '';
		this.model = {
			account: null,
			code: null,
			name: null,
			fatherAccount: null,
			level: null,
		};
		delete this.model.flagFather;
	}

	async function onDelete() {
		const params = {
			subsidiaryId: this.subsidiaryRow,
			customerId: this.customerId,
		};
		try {
			await this.$http.delete(`com-accounting-accounts/${this.accountId}`, { params });
			this.showNotification('La cuenta ha sido eliminada correctamente.');
			this.closeDialog();
			this.loadAccountingAccounts();
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			} else if (err.status === 400) {
				if (err.data.message === 'ACCOUNTING_ACCOUNT_NOT_FOUND') {
					this.showGenericError('La cuenta no existe.');
				} else if (err.data.message === 'ACCOUNTING_ACCOUNT_DEFINITION_ERROR') {
					this.showGenericError('La cuenta se encuentra asociada a una definición contable.');
				} else if (err.data.message === 'ACCOUNT_ASSOCIATED_ACCOUNTING_SEAT') {
					this.showNotification('No se puede borrar, cuenta asociada a un asiento contable', 'warning');
				}
			}
		} finally {
			this.closeDialog();
		}
	}

	async function exportRules() {
		try {
			this.isLoading = true;
			let urlService = '';
			const params = {
				subsidiaryId: this.subsidiaryId,
			};
			const accountingPlanIds = await this.$http.get('com-accounting-plan', { params });
			const accountingPlanIdActive = accountingPlanIds.data[0].id;
			const body = { accountingPlanId: accountingPlanIdActive	};
			urlService = 'reports/accounting-accounts';
			const { data: blobData } = await this.$http.post(urlService, body);
			const byteCharacters = atob(blobData.base64);
			const byteNumbers = [];
			byteCharacters.split('').forEach((char) => {
				byteNumbers.push(char.charCodeAt(0));
			});

			const byteArray = new Uint8Array(byteNumbers);
			const buffer = byteArray.buffer;

			// Crear un Blob a partir del ArrayBuffer
			const blob = new Blob([buffer], { type: 'application/octet-stream' });

			// Crear un objeto URL para descargar el archivo
			const url = URL.createObjectURL(blob);

			// Crear un enlace (link) para la descarga
			const link = document.createElement('a');
			link.href = url;
			link.download = 'reglas_contables_actual.xlsx'; // Cambia el nombre del archivo según desees

			// Simular un clic para iniciar la descarga
			link.click();

			// Revocar el objeto URL para liberar recursos del navegador
			URL.revokeObjectURL(url);
		} catch (error) {
			if (error.status === 400) {
				this.showNotification('Su compañía no cuenta con este reporte', 'warning');
			} else {
				this.showGenericError();
			}
		} finally {
			this.isLoading = false;
		}
	}

	async function loadNewlevel() {
		try {
			({ data: this.table.rows } = await this.$http.get(`com-accounting-accounts/${this.id}/plan?page=1&limit=20`));
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		}
	}

	function openConfirmation(row) {
		const { id, name, customerId, subsidiaryId } = row;
		this.customerId = customerId;
		this.subsidiaryRow = subsidiaryId;
		this.accountId = id;
		this.dialogMessage = `¿Desea eliminar la cuenta ${name} del listado?`;
		this.dialog = true;
	}

	function rowIsSelected({ id, account, isSelected }) {
		const rowIndex = this.dataSelected.findIndex(ds => ds.id === id);
		if (isSelected && rowIndex === -1) {
			this.dataSelected.push({ id, account });
		} else if (!isSelected && rowIndex > -1) {
			this.dataSelected.splice(rowIndex, 1);
		}
		this.checkAll = this.dataSelected.length === this.table.rows.length;
	}

	async function runAction({ code, codeWeb }) {
		try {
			if (code === 'accounting-account-new') {
				this.goTo(
					codeWeb,
					{
						params: {
							accountId: this.dataSelected[0].id,
							id: this.id,
							name: this.name,
							subsidiaryName: this.subsidiaryName,
							year: this.year,
						},
					},
				);
			} else if (code === 'accounting-accounts') {
				this.action.title = 'Crear Cuenta Contable';
				this.action.width = 500;
				this.action.value = true;
				this.action.code = code;
				if (this.accountingAccounts && this.accountingAccounts.length > 0) {
					const maxCode = Math.max(...this.accountingAccounts.map(row => parseInt(row.code, 10)));
					const newCode = String(maxCode + 1);
					this.model.account = `${newCode}`;
					const parts = this.model.account.split('.');
					const filteredParts = parts.filter(part => part !== '0').join('');
					this.model.code = filteredParts;
				} else {
					this.model.account = '1.';
					const parts = this.model.account.split('.');
					const filteredParts = parts.filter(part => part !== '0').join('');
					this.model.code = filteredParts;
				}
				this.model.level = 1;
				this.model.flagFather = true;
				delete this.model.fatherAccount;
			} else if (code === 'accounting-accounts-export') {
				this.action.title = 'Exportar Plan Contable';
				this.action.width = 500;
				this.action.value = true;
				this.action.code = code;
			} else if (code === 'accounting-accounts-auxiliary') {
				const subsidiary = await this.$http.get('subsidiary');
				const body = { auxCont: true };
				const url = `com-accounting-accounts/update-aux/${subsidiary.data[0].id}`;
				const responseAuxAccount = await this.$http.patch(url, body);
				if (responseAuxAccount.status === 200) {
					this.showNotification('Se actualizó correctamen las cuentas Auxiliar', 'success');
				}
			}
		} catch (error) {
			this.showGenericError();
		}
	}

	function searchTable(value) {
		this.onSearch(value, `com-accounting-accounts/${this.id}/plan`);
		this.currentPage = 1;
	}

	function selectedAll(checked) {
		this.checkAll = checked;
		this.table.rows = this.table.rows.map((row) => {
			const newRow = { ...row };
			newRow.isSelected = checked;
			return newRow;
		});
		this.dataSelected = this.table.rows.filter(r => r.isSelected);
	}

	function title() {
		return `${this.name} - ${this.$route.meta.title}`;
	}

	/* function valuesDisabled() {
		const disabled = this.dataSelected.length !== 1;
		return [{ code: 'accounting-account-new', disabled }];
	} */

	function onClickIcon(action, row) {
		if (action === 'delete') {
			this.openConfirmation(row);
		} else if (action === 'edit') {
			this.edit(row);
		} else if (action === 'add') {
			this.action.title = `Crear Cuenta Contable en ${row.name}`;
			this.action.width = 500;
			this.action.value = true;
			this.action.code = 'accounting-accounts';
			let newAccount = row.account;
			if (row.account && !row.account.endsWith('.')) {
				newAccount = `${newAccount}.`;
			}
			if (row.children && row.children.length > 0) {
				const maxCode = Math.max(...row.children.map((r) => {
					const parts = r.account.split('.').filter(Boolean);
					return parseInt(parts[parts.length - 1], 10);
				}));
				const newCode = String(maxCode + 1).padStart(2, '0');
				this.model.account = `${newAccount}${newCode}`;
				const parts = this.model.account.split('.');
				const filteredParts = parts.filter(part => part !== '0').join('');
				this.model.code = filteredParts;
			} else {
				this.model.account = `${newAccount}01`;
				const parts = this.model.account.split('.');
				const filteredParts = parts.filter(part => part !== '0').join('');
				this.model.code = filteredParts;
			}
			this.model.fatherAccount = row.code;
			this.model.level = row.level + 1;
		}
	}

	function data() {
		return {
			accountId: null,
			checkAll: false,
			flagCode: false,
			flagValue: false,
			action: {
				code: '',
				title: '',
				value: false,
				visible: false,
			},
			columns: [
				{
					id: 1,
					name: 'Cuenta',
					value: 'account',
					checked: true,
					visible: true,
					movil: true,
				},
				{
					id: 2,
					name: 'Nombre de la cuenta',
					value: 'name',
					checked: true,
					visible: true,
					movil: true,
				},
				{
					id: 3,
					name: 'Código',
					value: 'code',
					checked: true,
					visible: true,
					movil: true,
				},
				{
					id: 4,
					name: 'Padre',
					value: 'fatherAccount',
					checked: true,
					visible: true,
					movil: true,
				},
				/* {
					id: 5,
					name: 'Stat',
					value: 'stat',
					checked: true,
					visible: true,
					movil: true,
				}, */
				{
					id: 5,
					name: 'Tipo de Movimiento',
					checked: true,
					visible: true,
					flagVisible: true,
					movil: true,
				},
				{
					id: 6,
					name: 'Auxiliar Contable',
					checked: true,
					visible: true,
					flagVisible: true,
					movil: true,
				},
				{
					id: 7,
					name: 'Acciones',
					checked: true,
					visible: true,
					flagVisible: true,
					movil: true,
				},
			],
			currentPage: 1,
			code: null,
			model: {
				account: null,
				code: null,
				name: null,
				fatherAccount: null,
			},
			dataSelected: [],
			dialog: false,
			dialogMessage: '',
			levels: [],
			level: [],
			plansData: [],
			newData: [],
			accountingAccounts: [],
			params: {
				level: null,
			},
			dialogLoading: false,
			subsidiaryRow: null,
			customerId: null,
		};
	}

	export default {
		name: 'page-accounting-account',
		components: {
			accountingAccountFilter,
			accountingAccountList,
			actionBar,
			actionSidebar,
			backButtonRoute,
			treeTable,
		},
		computed: {
			title,
			disabled,
			// valuesDisabled,
		},
		created,
		data,
		methods: {
			closeDialog,
			submitForm,
			onLevel,
			edit,
			// setAccountData,
			onDelete,
			openConfirmation,
			closeModal,
			rowIsSelected,
			runAction,
			searchTable,
			selectedAll,
			loadNewlevel,
			exportRules,
			loadAccountingAccounts,
			onClickIcon,
		},
		props: {
			id: [Number, String],
			name: String,
			subsidiaryName: String,
			year: [Number, String],
		},
		watch: {
			$route(newVal) {
				if (newVal) {
					if (newVal.name === 'accounting-accounts') {
						this.loadAccountingAccounts();
						this.dataSelected = [];
					}
				}
			},
		},
		validations,
	};
</script>



// WEBPACK FOOTER //
// src/pages/accounting-accounts/page-accounting-account.vue